import { Trans } from '@lingui/react/macro';
import React from 'react';

function NoActiveCruiseNotice(props) {
    return (
        <div className="my-4">
            <Trans id="no_active_cruise_text">
                <div className="text-3xl">
                    No active cruise
                </div>
                <div className="text-grey-darker">
                    There are currently no active cruises for this booking.
                </div>
            </Trans>
        </div>
    );
}

export default NoActiveCruiseNotice;